export function minutesToTime(totalMinutes) {
    let negative = false;
    if (totalMinutes < 0) {
        totalMinutes = Math.abs(totalMinutes);
        negative = true;
    }
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes - hours * 60;
    return (
        (negative ? '-' : '') +
        (hours > 10 ? hours : ('0' + hours).slice(-2)) +
        ':' +
        ('0' + minutes).slice(-2)
    );
}
